import ShapesLinks from './Root.vue';
import ShapeLinksCreate from './views/ShapeLinksCreate.vue';
import ShapeLinksEdit from './views/ShapeLinksEdit.vue';
import ShapeLinksList from './views/ShapeLinksList.vue';

export default {
  path: 'gerador/shape-links',
  name: 'admin-shape-links',
  component: ShapesLinks,
  redirect: '/novo',
  children: [
    {
      path: 'lista/:page',
      name: 'admin-shape-links-list',
      component: ShapeLinksList,
    },
    {
      path: 'novo/',
      name: 'admin-shape-links-new',
      component: ShapeLinksCreate,
    },
    {
      path: ':puzzleId',
      name: 'admin-shape-links-edit',
      component: ShapeLinksEdit,
    },
  ],
};
